'use client';

import { c as _c } from "react/compiler-runtime";
import { SectionLabel } from '@/components/ui/section-label';
import { useRecentSearches } from '@/features/payload-cms/components/search/recent-searches';
import { filterChipClassName } from '@/features/payload-cms/components/search/search-filter-panel';
import { recentSearchesLabel } from '@/features/payload-cms/components/search/search-translations';
import type { Locale } from '@/types/types';
import { History } from 'lucide-react';
import type React from 'react';

/**
 * The searches of this device, as a way forward from an empty field or from no results, so the
 * search never ends in a blank state. Renders nothing before the first search.
 */
export const RecentSearches: React.FC<{
  locale: Locale;
  /** the query on screen, which is not offered again */
  current?: string;
  onPick: (query: string) => void;
  className?: string;
}> = t0 => {
  const $ = _c(23);
  const {
    locale,
    current: t1,
    onPick,
    className
  } = t0;
  const current = t1 === undefined ? "" : t1;
  const t2 = useRecentSearches();
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== className || $[1] !== current || $[2] !== locale || $[3] !== onPick || $[4] !== t2) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t8;
      if ($[10] !== current) {
        t8 = entry => entry.toLowerCase() !== current.trim().toLowerCase();
        $[10] = current;
        $[11] = t8;
      } else {
        t8 = $[11];
      }
      const recent = t2.filter(t8);
      if (recent.length === 0) {
        t7 = undefined;
        break bb0;
      }
      t5 = className;
      const t9 = recentSearchesLabel[locale];
      if ($[12] !== t9) {
        t6 = <SectionLabel as="h3">{t9}</SectionLabel>;
        $[12] = t9;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      t3 = "mt-2 flex flex-wrap gap-2";
      let t10;
      if ($[14] !== onPick) {
        t10 = entry_0 => <button key={entry_0} type="button" onClick={() => onPick(entry_0)} className={filterChipClassName(false)}><History className="h-4 w-4 text-green-500" aria-hidden="true" />{entry_0}</button>;
        $[14] = onPick;
        $[15] = t10;
      } else {
        t10 = $[15];
      }
      t4 = recent.map(t10);
    }
    $[0] = className;
    $[1] = current;
    $[2] = locale;
    $[3] = onPick;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t4) {
    t8 = <div className={t3}>{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t8) {
    t9 = <div className={t5}>{t6}{t8}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};